import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import './datePick.scss';

export function datePick() {
  flatpickr('[data-date-picker]', {
    mode: 'range',
    dateFormat: 'Y-m-d',
  });
}
